import { lazy } from "react";
import Loadable from "components/Loadable";
import { routeConstants } from "services/keyConstants";

// Lazy-loaded components
const AddEdit = Loadable(lazy(() => import("../molecules/AddEdit")));
const View = Loadable(lazy(() => import("../molecules/View")));
const Detail = Loadable(lazy(() => import("../molecules/Detail")));

// Export only children to be consumed in MainRoutes
const changeNoteRoute = [
  {
    path: routeConstants.CHANGE_NOTE,
    children: [
      {
        path: "detail/:id",
        element: <Detail />
      },
      {
        path: "manage/:id?",
        element: <AddEdit />
      },
      {
        path: "view/:id?",
        element: <View />
      }
    ]
  }
];

export default changeNoteRoute;